import { Checkbox, Col, Collapse, PageHeader, Row, Space, Spin, Tabs, Tag, message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { connect } from "react-redux";
import {
  ButtonItem,
  ErrorItem,
  Form,
  FormItem,
  RangePickerItem,
  TableItem,
  dineroDisabledMask,
} from "../../../../Components/Items";
import { FileExcelOutlined, FilePdfOutlined } from "@ant-design/icons";
import * as XLSX from "xlsx";
import moment from "moment";
import "moment/locale/es";
import {
  esNota,
  esAplicacionNota,
  filasQueSeAnulan,
  descargarExcelCobros,
  descargarPdfCobros,
  descargarExcelPagos,
  descargarPdfPagos,
} from "./exportarPapelesIVA";
moment.locale("es");
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const { TabPane } = Tabs;
const { Panel } = Collapse;

// --- Secciones del reporte ---

const SEC_CAUSADO = [
  { type: "section", label: "IVA  CAUSADO" },
  { type: "row",     label: "Actos o Actividades Gravados al 16%",  key: "actosGravados16" },
  { type: "row",     label: "Actos o Actividades Gravados al 8%",   key: "actosGravados8" },
  { type: "row",     label: "Actos o Actividades Gravados al 11%",  key: "actosGravados11" },
  { type: "row",     label: "Actos o Actividades Gravados al 0%",   key: "actosGravados0" },
  { type: "row",     label: "Actos o Actividades Exentos",          key: "actosExentos" },
  { type: "row",     label: "Actos o Actividades Gravados al 15%",  key: "actosGravados15" },
  { type: "row",     label: "Actos o Actividades Gravados al 10%",  key: "actosGravados10" },
  { type: "row",     label: "Actos o Actividades en Otras Tasas",   key: "actosOtrasTasas" },
  { type: "subtotal",label: "Suma Actos o Actividades Gravados",    key: "sumaActosGravados" },
  { type: "subtotal",label: "Suma Actos o Actividades Gravados (Redondeado)", key: "sumaActosGravadosRedondeado" },
  { type: "row",     label: "IVA Causado al 16%",   key: "ivaCausado16" },
  { type: "row",     label: "IVA Causado al 8%",    key: "ivaCausado8" },
  { type: "row",     label: "IVA Causado al 11%",   key: "ivaCausado11" },
  { type: "row",     label: "IVA Causado al 15%",   key: "ivaCausado15" },
  { type: "row",     label: "IVA Causado al 10%",   key: "ivaCausado10" },
  { type: "row",     label: "IVA Retenido",          key: "ivaRetenido" },
  { type: "row",     label: "ISR Retenido",          key: "isrRetenido" },
  { type: "row",     label: "Otras Retenciones",     key: "otrasRetenciones" },
  { type: "total",   label: "Total IVA Causado",     key: "totalIvaCausado" },
  { type: "subtotal",label: "Total IVA Causado (Redondeado)", key: "totalIvaCausadoRedondeado" },
];

const SEC_PAGADO = [
  { type: "section", label: "IVA  PAGADO  ACREDITABLE" },
  { type: "row",     label: "Actos y Actividades Pagados al 16%", key: "actosPagados16" },
  { type: "row",     label: "Actos y Actividades Pagados al 8%",  key: "actosPagados8" },
  { type: "row",     label: "Actos y Actividades Pagados al 11%", key: "actosPagados11" },
  { type: "row",     label: "Actos y Actividades Pagados al 0%",  key: "actosPagados0" },
  { type: "row",     label: "Actos y Actividades Exentos",        key: "actosExentosPagados" },
  { type: "row",     label: "Actos y Actividades Pagados al 15%", key: "actosPagados15" },
  { type: "row",     label: "Actos y Actividades Pagados al 10%", key: "actosPagados10" },
  { type: "subtotal",label: "Total Actos y Actividades Pagados",  key: "totalActosPagados" },
  { type: "subtotal",label: "Total Actos y Actividades Pagados (Redondeado)", key: "totalActosPagadosRedondeado" },
  { type: "row",     label: "IVA de Actos y Actividades Pagados al 16%", key: "ivaActosPagados16" },
  { type: "row",     label: "IVA de Actos y Actividades Pagados al 8%",  key: "ivaActosPagados8" },
  { type: "row",     label: "IVA de Actos y Actividades Pagados al 11%", key: "ivaActosPagados11" },
  { type: "row",     label: "IVA de Actos y Actividades Pagados al 15%", key: "ivaActosPagados15" },
  { type: "row",     label: "IVA de Actos y Actividades Pagados al 10%", key: "ivaActosPagados10" },
  { type: "row",     label: "IVA Retenido",          key: "ivaRetenidoPagos" },
  { type: "row",     label: "ISR Retenido",          key: "isrRetenidoPagos" },
  { type: "row",     label: "Otras Retenciones",     key: "otrasRetencionesPagos" },
  { type: "row",     label: "IEPS Pagado (no es IVA acreditable)", key: "iepsPagos" },
  { type: "total",   label: "Total IVA Acreditable",             key: "totalIvaAcreditable" },
  { type: "subtotal",label: "Total IVA Acreditable (Redondeado)", key: "totalIvaAcreditableRedondeado" },
];

const SEC_DETERMINACION = [
  { type: "section", label: "DETERMINACION  DEL  IVA" },
  { type: "row",     label: "IVA a Cargo", key: "ivaCargo" },
  { type: "row",     label: "IVA a Cargo (Redondeado)", key: "ivaCargoRedondeado" },
  { type: "row",     label: "IVA a Favor", key: "ivaFavor" },
  { type: "row",     label: "IVA a Favor (Redondeado)", key: "ivaFavorRedondeado" },
];

// Needed for PDF/Excel export of the full report
const ESTRUCTURA = [
  ...SEC_CAUSADO,   { type: "spacer" },
  ...SEC_PAGADO,    { type: "spacer" },
  ...SEC_DETERMINACION,
];

// --- FilaReporte ---

function FilaReporte({ fila, data }) {
  const valor = data ? data[fila.key] : undefined;

  if (fila.type === "spacer") return <div style={{ height: 16 }} />;

  if (fila.type === "section") {
    return (
      <Row style={{ marginTop: 8, marginBottom: 4 }}>
        <Col style={{ fontWeight: 700, letterSpacing: 2, fontSize: 13 }}>{fila.label}</Col>
      </Row>
    );
  }

  const esTotal    = fila.type === "total";
  const esSubtotal = fila.type === "subtotal";

  return (
    <Row
      align="middle"
      style={{ marginBottom: esTotal ? 7 : 2, borderTop: esTotal ? "1px solid #555" : "none" }}
    >
      <Col
        flex="1"
        style={{ paddingLeft: esTotal || esSubtotal ? 0 : 10, fontWeight: esTotal || esSubtotal ? 700 : 400, fontSize: 13 }}
      >
        {fila.label}
      </Col>
      <Col>
        <div
          style={{
            background: "#fff",
            minWidth: 155,
            textAlign: "right",
            padding: "2px 8px",
            fontWeight: esTotal || esSubtotal ? 700 : 400,
            fontSize: 14,
          }}
        >
          {data ? dineroDisabledMask(valor ?? 0) : ""}
        </div>
      </Col>
    </Row>
  );
}

// --- Columnas del papel de trabajo ---

const rIVA = (v) => (
  <span style={{ fontWeight: 700 }}>{dineroDisabledMask(v || 0)}</span>
);

const sumaCampo = (filas, campo) =>
  Math.round((filas || []).reduce((acc, r) => acc + (Number(r[campo]) || 0), 0) * 100) / 100;

// Mismo criterio que la DIOT y la contabilidad: la nota de credito llega con todos
// sus importes en negativo (NC) y su aplicacion a un saldo llega en positivo como
// un pago mas del documento (Aplic. NC). Si la nota se aplico a un saldo pendiente,
// los dos renglones se anulan.
const COL_TIPO = {
  title: "Tipo", dataIndex: "tipo", key: "tipo", width: 90,
  render: (v, r) => {
    if (esNota(r)) return <Tag color="red">NC</Tag>;
    if (esAplicacionNota(r)) return <Tag color="blue">Aplic. NC</Tag>;
    return null;
  },
};

const COL_FECHA = {
  title: "Fecha", dataIndex: "fechaPago", key: "fechaPago", width: 100,
  render: (v) => (v ? moment(v).format("DD/MM/YYYY") : "—"),
};

const COLS_COBROS = [
  COL_TIPO,
  COL_FECHA,
  { title: "Cliente", dataIndex: "nombreCliente", key: "nombreCliente", width: 160, ellipsis: true },
  { title: "Documento", dataIndex: "serieNumero", key: "serieNumero", width: 90 },
  // En una nota: las ventas que relaciona. En una aplicacion: la nota aplicada.
  { title: "Relacionado", dataIndex: "relacionado", key: "relacionado", width: 110, ellipsis: true },
  {
    title: "Monto", dataIndex: "monto", key: "monto", width: 110, align: "right",
    render: (v) => dineroDisabledMask(v || 0),
  },
  {
    title: "Total a Pagar", dataIndex: "totalPagar", key: "totalPagar", width: 120, align: "right",
    render: (v) => dineroDisabledMask(v || 0),
  },
  { title: "Base 16%", dataIndex: "actosGravados16", key: "actosGravados16", width: 105, align: "right", render: (v) => dineroDisabledMask(v || 0) },
  { title: "IVA 16%",  dataIndex: "ivaCausado16",    key: "ivaCausado16",    width: 105, align: "right", render: (v) => dineroDisabledMask(v || 0) },
  { title: "Base 8%",  dataIndex: "actosGravados8",  key: "actosGravados8",  width: 105, align: "right", render: (v) => dineroDisabledMask(v || 0) },
  { title: "IVA 8%",   dataIndex: "ivaCausado8",     key: "ivaCausado8",     width: 105, align: "right", render: (v) => dineroDisabledMask(v || 0) },
  { title: "Base 11%", dataIndex: "actosGravados11", key: "actosGravados11", width: 105, align: "right", render: (v) => dineroDisabledMask(v || 0) },
  { title: "IVA 11%",  dataIndex: "ivaCausado11",    key: "ivaCausado11",    width: 105, align: "right", render: (v) => dineroDisabledMask(v || 0) },
  { title: "Base 0%",  dataIndex: "actosGravados0",  key: "actosGravados0",  width: 105, align: "right", render: (v) => dineroDisabledMask(v || 0) },
  { title: "Exentos",  dataIndex: "actosExentos",    key: "actosExentos",    width: 105, align: "right", render: (v) => dineroDisabledMask(v || 0) },
  { title: "Otras Tasas", dataIndex: "actosOtrasTasas", key: "actosOtrasTasas", width: 110, align: "right", render: (v) => dineroDisabledMask(v || 0) },
  { title: "Base 15%", dataIndex: "actosGravados15", key: "actosGravados15", width: 105, align: "right", render: (v) => dineroDisabledMask(v || 0) },
  { title: "IVA 15%",  dataIndex: "ivaCausado15",    key: "ivaCausado15",    width: 105, align: "right", render: (v) => dineroDisabledMask(v || 0) },
  { title: "Base 10%", dataIndex: "actosGravados10", key: "actosGravados10", width: 105, align: "right", render: (v) => dineroDisabledMask(v || 0) },
  { title: "IVA 10%",  dataIndex: "ivaCausado10",    key: "ivaCausado10",    width: 105, align: "right", render: (v) => dineroDisabledMask(v || 0) },
  { title: "IVA Retenido", dataIndex: "ivaRetenido", key: "ivaRetenido",     width: 110, align: "right", render: (v) => dineroDisabledMask(v || 0) },
  { title: "ISR Retenido", dataIndex: "isrRetenido", key: "isrRetenido",     width: 110, align: "right", render: (v) => dineroDisabledMask(v || 0) },
  { title: "Otras Retenciones", dataIndex: "otrasRetenciones", key: "otrasRetenciones", width: 130, align: "right", render: (v) => dineroDisabledMask(v || 0) },
  { title: "Total IVA", dataIndex: "totalIvaFila",   key: "totalIvaFila",    width: 115, align: "right", render: rIVA },
];

const COLS_PAGOS = [
  COL_TIPO,
  COL_FECHA,
  { title: "Proveedor", dataIndex: "proveedorNombre", key: "proveedorNombre", width: 160, ellipsis: true },
  { title: "Folio", dataIndex: "numeroFactura", key: "numeroFactura", width: 100 },
  // En una nota: las facturas que relaciona. En una aplicacion: la nota aplicada.
  { title: "Relacionado", dataIndex: "relacionado", key: "relacionado", width: 110, ellipsis: true },
  { title: "Descripción", dataIndex: "descripcionFactura", key: "descripcionFactura", width: 160, ellipsis: true },
  {
    title: "UUID", dataIndex: "uuid", key: "uuid", width: 110,
    render: (v) => (v ? v.substring(0, 8) + "…" : "—"),
  },
  { title: "Monto",  dataIndex: "monto",      key: "monto",      width: 110, align: "right", render: (v) => dineroDisabledMask(v || 0) },
  { title: "Total a Pagar", dataIndex: "totalPagar", key: "totalPagar", width: 120, align: "right", render: (v) => dineroDisabledMask(v || 0) },
  { title: "Base 16%", dataIndex: "actosPagados16",     key: "actosPagados16",     width: 105, align: "right", render: (v) => dineroDisabledMask(v || 0) },
  { title: "IVA 16%",  dataIndex: "ivaActosPagados16",  key: "ivaActosPagados16",  width: 105, align: "right", render: (v) => dineroDisabledMask(v || 0) },
  { title: "Base 8%",  dataIndex: "actosPagados8",      key: "actosPagados8",      width: 105, align: "right", render: (v) => dineroDisabledMask(v || 0) },
  { title: "IVA 8%",   dataIndex: "ivaActosPagados8",   key: "ivaActosPagados8",   width: 105, align: "right", render: (v) => dineroDisabledMask(v || 0) },
  { title: "Base 11%", dataIndex: "actosPagados11",     key: "actosPagados11",     width: 105, align: "right", render: (v) => dineroDisabledMask(v || 0) },
  { title: "IVA 11%",  dataIndex: "ivaActosPagados11",  key: "ivaActosPagados11",  width: 105, align: "right", render: (v) => dineroDisabledMask(v || 0) },
  { title: "Base 0%",  dataIndex: "actosPagados0",      key: "actosPagados0",      width: 105, align: "right", render: (v) => dineroDisabledMask(v || 0) },
  { title: "Exentos",  dataIndex: "actosExentosPagados", key: "actosExentosPagados", width: 105, align: "right", render: (v) => dineroDisabledMask(v || 0) },
  { title: "Base 15%", dataIndex: "actosPagados15",     key: "actosPagados15",     width: 105, align: "right", render: (v) => dineroDisabledMask(v || 0) },
  { title: "IVA 15%",  dataIndex: "ivaActosPagados15",  key: "ivaActosPagados15",  width: 105, align: "right", render: (v) => dineroDisabledMask(v || 0) },
  { title: "Base 10%", dataIndex: "actosPagados10",     key: "actosPagados10",     width: 105, align: "right", render: (v) => dineroDisabledMask(v || 0) },
  { title: "IVA 10%",  dataIndex: "ivaActosPagados10",  key: "ivaActosPagados10",  width: 105, align: "right", render: (v) => dineroDisabledMask(v || 0) },
  // El IEPS no es IVA acreditable: se informa aparte, sin entrar al Total IVA.
  { title: "IEPS",     dataIndex: "iepsPagado",         key: "iepsPagado",         width: 105, align: "right", render: (v) => dineroDisabledMask(v || 0) },
  { title: "IVA Retenido", dataIndex: "ivaRetenido", key: "ivaRetenido",     width: 110, align: "right", render: (v) => dineroDisabledMask(v || 0) },
  { title: "ISR Retenido", dataIndex: "isrRetenido", key: "isrRetenido",     width: 110, align: "right", render: (v) => dineroDisabledMask(v || 0) },
  { title: "Otras Retenciones", dataIndex: "otrasRetenciones", key: "otrasRetenciones", width: 130, align: "right", render: (v) => dineroDisabledMask(v || 0) },
  { title: "Total IVA", dataIndex: "totalIvaFila",      key: "totalIvaFila",      width: 115, align: "right", render: rIVA },
];

// Los importes fiscales de cada papel: lo que una nota y su aplicacion tienen que
// anular para ocultarse. Ni el Monto (en moneda del pago) ni el Total a Pagar (del
// documento) cuentan.
const camposFiscales = (columnas) =>
  columnas
    .filter((c) => c.align === "right" && c.dataIndex !== "monto" && c.dataIndex !== "totalPagar")
    .map((c) => c.dataIndex);

const CAMPOS_FISCALES = {
  papelTrabajoCobros: camposFiscales(COLS_COBROS),
  papelTrabajoPagos: camposFiscales(COLS_PAGOS),
};

// --- Clase principal ---

class ReporteIVA extends Component {
  formRef = React.createRef();

  state = {
    loading: false,
    dataReporte: null,
    // El periodo consultado (no el del formulario) alimenta el encabezado de los
    // Excel y PDF, para que digan el rango que se descargo y no el que se ve.
    periodo: null,
    // "No mostrar pagos de notas de credito" (Detalles). Solo cambia los renglones
    // que se ven, no los totales: se aplica al momento, sin volver a consultar.
    ocultarNotasAnuladas: true,
  };

  atras() {
    this.props.history.goBack();
  }

  async componentDidMount() {
    const inicioMes = moment().startOf("month");
    const finMes    = moment().endOf("month");
    this.consultarReporte({ periodo: [inicioMes, finMes] });
  }

  consultarReporte(values) {
    this.setState({ loading: true });
    axios
      .post(
        "reportesFiscales/reporteIVA",
        {
          empresaId:   this.props.empresaId,
          fechaInicio: values.periodo[0],
          fechaFin:    values.periodo[1],
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({ dataReporte: res.data, periodo: values.periodo, loading: false });
        } else {
          message.error("Ha sucedido un error al cargar el reporte");
          this.setState({ loading: false });
        }
      })
      .catch(() => {
        message.error("Error de conexión");
        this.setState({ loading: false });
      });
  }

  // --- Descarga reporte completo ---

  descargarExcel() {
    const { dataReporte } = this.state;
    if (!dataReporte) return;
    const filas = ESTRUCTURA.filter((f) => f.type !== "spacer" && f.type !== "section").map((f) => ({
      Concepto: f.label,
      Importe:  dataReporte[f.key] ?? 0,
    }));
    const ws = XLSX.utils.json_to_sheet(filas);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Reporte IVA");
    XLSX.writeFile(wb, `Reporte_IVA_${moment().format("YYYY-MM")}.xlsx`);
  }

  descargarPdf() {
    const { dataReporte } = this.state;
    if (!dataReporte) return;
    const body = ESTRUCTURA.map((fila) => {
      if (fila.type === "spacer")  return [{ text: "", colSpan: 2, border: [false,false,false,false] }, {}];
      if (fila.type === "section") return [{ text: fila.label, bold: true, colSpan: 2, border: [false,false,false,true], fontSize: 10, margin: [0,6,0,2] }, {}];
      const bold = fila.type === "total" || fila.type === "subtotal";
      return [
        { text: fila.label,                                     bold, margin: bold ? [0,0,0,0] : [12,0,0,0], fontSize: 9 },
        { text: dineroDisabledMask(dataReporte[fila.key] ?? 0), bold, alignment: "right", fontSize: 9 },
      ];
    });
    const docDef = {
      pageSize: "LETTER",
      content: [
        { text: this.props.empresa || "", style: "empresa" },
        { text: "Reporte IVA", style: "titulo" },
        { table: { widths: ["*", 120], body }, layout: { hLineColor: () => "#cccccc", vLineWidth: () => 0 } },
      ],
      styles: {
        empresa: { fontSize: 11, bold: true, alignment: "center", margin: [0,0,0,2] },
        titulo:  { fontSize: 13, bold: true, alignment: "center", margin: [0,0,0,12] },
      },
    };
    pdfMake.createPdf(docDef).download(`Reporte_IVA_${moment().format("YYYY-MM")}.pdf`);
  }

  // --- Papeles de trabajo ---
  //
  // Excel y PDF salen de la misma definicion de tabla (`exportarPapelesIVA`), asi
  // que no pueden decir cosas distintas.

  // Los renglones del papel que se ven en pantalla y que van al Excel y al PDF.
  papelVisible(clave) {
    const datos = this.state.dataReporte?.[clave] || [];
    if (!this.state.ocultarNotasAnuladas) return { filas: datos, notasOcultas: 0 };
    const anuladas = filasQueSeAnulan(datos, CAMPOS_FISCALES[clave]);
    return {
      filas: datos.filter((r) => !anuladas.has(r)),
      notasOcultas: [...anuladas].filter(esNota).length,
    };
  }

  descargarPapel(clave, descargador, aviso) {
    const { filas, notasOcultas } = this.papelVisible(clave);
    if (filas.length === 0) { message.warning(aviso); return; }
    descargador({
      datos: filas,
      notasOcultas,
      empresaNombre: this.props.empresa,
      periodo: this.state.periodo,
    });
  }

  descargarExcelPapelCobros() {
    this.descargarPapel("papelTrabajoCobros", descargarExcelCobros, "No hay datos de cobros");
  }

  descargarPdfPapelCobros() {
    this.descargarPapel("papelTrabajoCobros", descargarPdfCobros, "No hay datos de cobros");
  }

  descargarExcelPapelPagos() {
    this.descargarPapel("papelTrabajoPagos", descargarExcelPagos, "No hay datos de pagos");
  }

  descargarPdfPapelPagos() {
    this.descargarPapel("papelTrabajoPagos", descargarPdfPagos, "No hay datos de pagos");
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  onValuesChange(cambios) {
    if ("ocultarNotasAnuladas" in cambios) {
      this.setState({ ocultarNotasAnuladas: cambios.ocultarNotasAnuladas });
    }
  }

  renderPapelTrabajo(titulo, { filas: data, notasOcultas }, columns, keyField, onExcel, onPdf) {
    return (
      <Collapse>
        <Panel header={`Papel de trabajo — ${titulo}`} key="pt">
          <Space style={{ marginBottom: 10 }}>
            <ButtonItem blanco size="small" icon={<FileExcelOutlined />} onClick={onExcel}>
              Excel
            </ButtonItem>
            <ButtonItem blanco size="small" icon={<FilePdfOutlined />} onClick={onPdf}>
              PDF
            </ButtonItem>
            {notasOcultas > 0 && (
              <span style={{ color: "#8c8c8c", fontSize: 12 }}>
                {notasOcultas} nota(s) de crédito no se muestran junto con su aplicación: se anulan entre sí
              </span>
            )}
          </Space>
          <TableItem
            size="small"
            // Un pago que liquida varios documentos genera varias filas con el
            // mismo id, de ahi el indice en la llave.
            dataSource={data.map((r, i) => ({ ...r, key: `${r[keyField] || "fila"}-${i}` }))}
            columns={columns}
            rowClassName={(r) => (esNota(r) ? "fila-nota-credito" : "")}
            pagination={{ pageSize: 10, hideOnSinglePage: true }}
            scroll={{ x: "max-content" }}
            summary={() => {
              if (data.length === 0) return null;
              return (
                <TableItem.Summary.Row>
                  {columns.map((col, idx) => {
                    if (idx === 0) {
                      return (
                        <TableItem.Summary.Cell key={col.key} index={idx}>
                          <b>TOTAL</b>
                        </TableItem.Summary.Cell>
                      );
                    }
                    // "Total a Pagar" es el total del documento y se repite en cada
                    // aplicacion de pago: sumarlo no significa nada.
                    if (col.align !== "right" || col.dataIndex === "totalPagar") {
                      return <TableItem.Summary.Cell key={col.key} index={idx} />;
                    }
                    const total = sumaCampo(data, col.dataIndex);
                    const esIva = col.dataIndex === "totalIvaFila";
                    return (
                      <TableItem.Summary.Cell key={col.key} index={idx} align="right">
                        <span style={{ fontWeight: esIva ? 700 : 600 }}>{dineroDisabledMask(total)}</span>
                      </TableItem.Summary.Cell>
                    );
                  })}
                </TableItem.Summary.Row>
              );
            }}
          />
        </Panel>
      </Collapse>
    );
  }

  render() {
    const { loading, dataReporte } = this.state;

    return (
      <>
        <Form
          ref={this.formRef}
          name="reporteIVA"
          onFinish={this.consultarReporte.bind(this)}
          onFinishFailed={this.onFinishFailed}
          onValuesChange={this.onValuesChange.bind(this)}
          initialValues={{
            periodo: [moment().startOf("month"), moment().endOf("month")],
            ocultarNotasAnuladas: true,
          }}
        >
          <PageHeader
            onBack={this.atras.bind(this)}
            title="Reporte IVA"
            style={{
              border: "1px solid rgb(235, 237, 240)",
              backgroundColor: "white",
              marginBottom: 10,
            }}
            extra={
              <Space>
                {dataReporte && (
                  <ButtonItem blanco icon={<FileExcelOutlined />} onClick={() => this.descargarExcel()}>
                    Descargar Excel
                  </ButtonItem>
                )}
                {dataReporte && (
                  <ButtonItem blanco icon={<FilePdfOutlined />} onClick={() => this.descargarPdf()}>
                    Descargar PDF
                  </ButtonItem>
                )}
                <ButtonItem type="primary" htmlType="submit">
                  Consultar
                </ButtonItem>
              </Space>
            }
          />

          <Spin spinning={loading}>
            {/* Filtros */}
            <div
              style={{
                backgroundColor: "white",
                padding: 20,
                paddingTop: 5,
                borderRadius: 5,
                boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
              }}
            >
              <Tabs
                style={{ margin: 0 }}
                tabBarExtraContent={{
                  left: <h1 style={{ padding: 0, margin: "0 10px 0 0" }}>Filtros:</h1>,
                }}
              >
                <TabPane tab="Periodo" key="1" forceRender>
                  <Row>
                    <Col span={12}>
                      <FormItem name="periodo" required noStyle>
                        <RangePickerItem />
                      </FormItem>
                    </Col>
                  </Row>
                </TabPane>
                <TabPane tab="Detalles" key="2" forceRender>
                  <Row>
                    <Col span={12}>
                      <FormItem
                        label="No mostrar pagos de notas de crédito"
                        tooltip="Oculta la nota de crédito y su aplicación (Aplic. NC) cuando se anulan entre sí en el periodo. Las que sí mueven el IVA se siguen mostrando y los totales no cambian."
                        name="ocultarNotasAnuladas"
                        valuePropName="checked"
                        margin
                      >
                        <Checkbox />
                      </FormItem>
                    </Col>
                  </Row>
                </TabPane>
              </Tabs>
            </div>

            <Row gutter={16} wrap={false} align="top" style={{ marginTop: 10 }}>
              {/* Card izquierda: todos los montos */}
              <Col flex="0 0 560px">
                <div style={{ backgroundColor: "white", padding: "20px 28px", borderRadius: 5, boxShadow: "0 4px 14px rgba(0,0,0,0.08)" }}>
                  {SEC_CAUSADO.map((fila, i) => (
                    <FilaReporte key={fila.key || `causado-${i}`} fila={fila} data={dataReporte} />
                  ))}
                  <div style={{ height: 20 }} />
                  {SEC_PAGADO.map((fila, i) => (
                    <FilaReporte key={fila.key || `pagado-${i}`} fila={fila} data={dataReporte} />
                  ))}
                  <div style={{ height: 20 }} />
                  {SEC_DETERMINACION.map((fila, i) => (
                    <FilaReporte key={fila.key || `det-${i}`} fila={fila} data={dataReporte} />
                  ))}
                </div>
              </Col>

              {/* Card derecha: todos los collapses */}
              <Col flex="1" style={{ minWidth: 0 }}>
                <div style={{ backgroundColor: "white", padding: "20px 20px", borderRadius: 5, boxShadow: "0 4px 14px rgba(0,0,0,0.08)" }}>
                  {this.renderPapelTrabajo(
                    "Cobros (IVA Causado)",
                    this.papelVisible("papelTrabajoCobros"),
                    COLS_COBROS,
                    "cobroId",
                    () => this.descargarExcelPapelCobros(),
                    () => this.descargarPdfPapelCobros()
                  )}
                  <div style={{ height: 10 }} />
                  {this.renderPapelTrabajo(
                    "Pagos a Proveedores (IVA Acreditable)",
                    this.papelVisible("papelTrabajoPagos"),
                    COLS_PAGOS,
                    "pagoId",
                    () => this.descargarExcelPapelPagos(),
                    () => this.descargarPdfPapelPagos()
                  )}
                </div>
              </Col>
            </Row>
          </Spin>
        </Form>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId:    state.empresa.id,
  empresa:      state.empresa.nombre,
});

export default connect(mapStateToProps)(ReporteIVA);
